import script from "./UtteranceListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./UtteranceListItem.vue?vue&type=script&lang=ts&setup=true"

import "./UtteranceListItem.vue?vue&type=style&index=0&id=3b86f3e8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b86f3e8"]])

export default __exports__